import { Component, HostListener, Inject, OnInit } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

@Component({
	selector: "tg-confirm-dialog",
	templateUrl: "./confirm-dialog.component.html",
	styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		private data: { title?: string; icon?: string; text: string; strings?: { [key: string]: string } },
		private ref: MatDialogRef<ConfirmDialogComponent>
	) {}

	ngOnInit(): void {}
	@HostListener("document:keydown.escape")
	onEscape() {
		this.ref.close(false);
	}
	get title() {
		return this.data.title;
	}
	get icon() {
		return this.data.icon;
	}
	get message() {
		return this.data.text;
	}
	get strings() {
		return this.data.strings || {};
	}
}
